var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isActive)?_c('div',[_c('permit',{on:{"stepCompleted":function($event){_vm.stepCompleted = $event}}}),_c('v-btn',{staticClass:"mt-5 mb-1",attrs:{"disabled":_vm.isActive && !_vm.validate(),"color":"primary"},on:{"click":function($event){return _vm.completed()}}},[_vm._v(" "+_vm._s(_vm.$t("next"))+" ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }